import { render, staticRenderFns } from "./TrackCover_c3.vue?vue&type=template&id=43b14e93&"
import script from "./TrackCover_c3.vue?vue&type=script&lang=js&"
export * from "./TrackCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports